import { useKBar } from 'kbar'
import { useEffect } from 'react'

export const useKBarShortcuts = () => {
  const { query } = useKBar()

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.repeat) {
        return
      }

      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault()
        query.toggle()
        return
      }

      if (event.key === '/' && !event.metaKey && !event.ctrlKey && !event.altKey) {
        const activeElement = document.activeElement
        const isInputField =
          activeElement instanceof HTMLInputElement ||
          activeElement instanceof HTMLTextAreaElement ||
          activeElement instanceof HTMLSelectElement ||
          activeElement?.isContentEditable ||
          activeElement?.closest('[data-kbar-search]')

        if (!isInputField) {
          event.preventDefault()
          query.toggle()
        }
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [query])

  return { toggle: query.toggle }
}

export const useKBarActions = () => {
  const { query } = useKBar()

  const openWithQuery = (searchQuery = '') => {
    query.toggle()
    setTimeout(() => {
      const input = document.querySelector('[data-kbar-search]')
      if (input) {
        input.value = searchQuery
        input.dispatchEvent(new Event('input', { bubbles: true }))
      }
    }, 100)
  }

  return {
    open: query.toggle,
    openWithQuery,
  }
}
